import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Header from '../component/Header'
import Footer from '../component/Footer'
import HomeRealEstateAgentForm from '../component/HomeRealEstateAgentForm'
import ExploreResultLocations from '../component/ExploreResultLocations'
import RecommendedYou from '../component/RecommendedYou'
import ProductRentView from '../component/ProductRentView'
import ProductRentDetails from '../component/ProductRentDetails'
import { GET_PROPERTY_BY_SLUG } from '../api/constants'
import { useProperty } from "../hooks/useProperty";

function RentDetails() {
    const { property, loading } = useProperty();

  if (loading) return <div>Loading...</div>;
  if (!property) return <div>Property not found</div>;
  return (
    <>
      <div className='main product-details'>
          <Header />
          <ProductRentView property={property} />
          <ProductRentDetails property={property} />
          <HomeRealEstateAgentForm property={property} />
          <RecommendedYou/>
          <ExploreResultLocations />
          <Footer />
      </div>
    </>
  )
}
export default RentDetails


